import type { JudgeResponse } from "./types";

/** Mirrors iOS JudgeCardView.buildSpokenJudgeText. */
export function buildSpokenJudgeText(
  verdict: JudgeResponse,
  providerLookup: (id: string) => string | undefined,
): string {
  const winnerId = verdict.winner.trim();
  const winnerName = winnerId
    ? (providerLookup(winnerId) ?? winnerId.toLocaleLowerCase().replace(/\b\w/g, (letter) => letter.toLocaleUpperCase()))
    : "";
  const winnerScore = verdict.scores?.[winnerId] ?? 0;
  const parts: string[] = [];

  if (winnerName) {
    parts.push(
      winnerScore > 0
        ? `${winnerName} won with a score of ${winnerScore} out of 10.`
        : `${winnerName} won.`,
    );
  }
  const rationale = verdict.rationale.trim();
  if (rationale) parts.push(rationale);
  if (verdict.synthesis) parts.push("Here's the best-of synthesis:", verdict.synthesis);
  return parts.join("\n\n");
}

/** iOS uses the winner-specific card id for TTS cache and playback identity. */
export function judgeSpeechCardId(verdict: JudgeResponse): string {
  return `judge-${verdict.winner}`;
}
